/**
 * Animacje „zwróć uwagę" przy kliknięciu W TŁO okna modal / wysuwanej szuflady.
 * Okna nie zamykają się klikiem w tło (tylko X / przycisk ze stopki), więc delikatny ruch
 * sygnalizuje userowi, że to otwarte okno i trzeba je zamknąć świadomie.
 *
 * Użycie: na elemencie-tle (overlay/backdrop) ustaw onClick={shakeModal} (modal) lub
 * onClick={nudgeDrawer} (szuflada). Animacja odpala się TYLKO przy kliknięciu w samo tło
 * (e.target === e.currentTarget), nie przy kliknięciu w zawartość okna.
 */

// Modal (wyśrodkowany) — delikatne trzęsienie poziome.
const SHAKE = [
    { transform: "translateX(0)" },
    { transform: "translateX(-8px)" },
    { transform: "translateX(8px)" },
    { transform: "translateX(-6px)" },
    { transform: "translateX(6px)" },
    { transform: "translateX(-3px)" },
    { transform: "translateX(3px)" },
    { transform: "translateX(0)" },
];

// Szuflada (z boku) — najpierw w prawo, potem w lewo, potem spokój.
const NUDGE = [
    { transform: "translateX(0)" },
    { transform: "translateX(14px)" },
    { transform: "translateX(-9px)" },
    { transform: "translateX(5px)" },
    { transform: "translateX(0)" },
];

const prefersReducedMotion = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const animateAttention = (el, keyframes, duration) => {
    if (!el || typeof el.animate !== "function" || prefersReducedMotion()) return;
    try {
        el.animate(keyframes, { duration, easing: "ease-in-out" });
    } catch {
        /* WAAPI niedostępne — pomiń (brak animacji to nie błąd) */
    }
};

// Element zawartości okna: dziecko tła; dla pustego overlaya (panel = rodzeństwo) — rodzeństwo.
const contentOf = (overlay) =>
    overlay?.firstElementChild || overlay?.nextElementSibling || overlay?.previousElementSibling || null;

/** onClick na tle modala — poziome trzęsienie zawartości (tylko klik w samo tło). */
export const shakeModal = (e) => {
    if (e.target !== e.currentTarget) return;
    animateAttention(contentOf(e.currentTarget), SHAKE, 430);
};

/** onClick na tle szuflady — szturchnięcie panelu prawo→lewo (tylko klik w samo tło). */
export const nudgeDrawer = (e) => {
    if (e.target !== e.currentTarget) return;
    animateAttention(contentOf(e.currentTarget), NUDGE, 470);
};
